import { RepositoryError } from './RepositoryError';
export class AuthenticationError extends RepositoryError {
    constructor(message, options) {
        super(message, options);
        this.name = 'AuthenticationError';
    }
}
